import { signMessage, } from '../actions/signMessage.js';
import {} from '../createConfig.js';
import {} from '../types/utils.js';
import {} from './types.js';
export function signMessageMutationOptions(config) {
    return {
        mutationFn(variables) {
            return signMessage(config, variables);
        },
        mutationKey: ['signMessage'],
    };
}
//# sourceMappingURL=signMessage.js.map